import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreateSubscriptionsErrorCode, CreateSubscriptionsResponse } from '@cmctechnology/phoenix-stockbroking-api-client';
import { API_RESPONSE_SUCCESS, DEFAULT_SUBSCRIPTION_INVEST, PricingSubscriptionResult, PricingSubscriptionType } from './constants';
import { IPricingSubscription } from './types';

export const SUBSCRIPTIONS_STORE_NAME = `subscriptions`;

export interface ISubscriptionsStore {
  pricingSubscription?: IPricingSubscription;
  pricingSubscriptionResult?: PricingSubscriptionResult;
  pricingSubscribeResult?: PricingSubscriptionResult;
}

export const defaultSubscriptionsStore: ISubscriptionsStore = {};

export const createSubscriptionsStore = (initialState: ISubscriptionsStore) =>
  createSlice({
    name: SUBSCRIPTIONS_STORE_NAME,
    initialState,
    reducers: {
      storeReset: () => defaultSubscriptionsStore,

      pricingSubscriptionFetched: (store, action: PayloadAction<any>) => {
        store.pricingSubscriptionResult = PricingSubscriptionResult.Success;

        if (action.payload.CurrentPackageName) {
          store.pricingSubscription = {
            currentSubscription: action.payload.CurrentPackageName as PricingSubscriptionType,
            currentSubscriptionEndDate: action.payload.EndDate,
            nextSubscription: action.payload.PackageName as PricingSubscriptionType,
            eligibleTypesToSubscribe: []
          };
          if (store.pricingSubscription.currentSubscription === PricingSubscriptionType.Platinum) {
            store.pricingSubscription.eligibleTypesToSubscribe.push(PricingSubscriptionType.Diamond);
          }
        } else {
          store.pricingSubscription = {
            ...DEFAULT_SUBSCRIPTION_INVEST,
            currentSubscriptionEndDate: action.payload.EndDate ?? ''
          };
        }
      },
      pricingSubscriptionSubscribed: (store, action: PayloadAction<CreateSubscriptionsResponse>) => {
        if (action.payload.result === API_RESPONSE_SUCCESS) {
          store.pricingSubscribeResult = PricingSubscriptionResult.Success;
        } else {
          store.pricingSubscribeResult =
            action.payload.message === CreateSubscriptionsErrorCode.Not_enough_balance
              ? PricingSubscriptionResult.InsufficientFund
              : PricingSubscriptionResult.SubscribeFailure;
        }
      },
      pricingSubscribeResultReset: (store) => {
        store.pricingSubscribeResult = undefined;
      }
    }
  });

export const { actions, reducer } = createSubscriptionsStore(defaultSubscriptionsStore);

export const createStore = (initialStore: ISubscriptionsStore = defaultSubscriptionsStore) =>
  configureStore({ reducer: { [SUBSCRIPTIONS_STORE_NAME]: createSubscriptionsStore(initialStore).reducer } });

export const SubscriptionsStore = createStore();

export type IStore = ReturnType<typeof SubscriptionsStore.getState>;
